export default __webpack_public_path__ + "static/media/Security code.62c1650c.svg";